import { DateTime } from 'luxon';
import { getEventListBounds } from '@/features/events/lib/eventListWindow.lib';
import type { DateTimeRange } from '@/features/events/lib/range.lib';
import { getDisplayTimezone } from '@/features/experiences/lib/experience';
import type { PageExperience } from '@/features/experiences/types';

export const getDayRangeBounds = (
  experience: PageExperience
): { start: DateTime; end: DateTime } =>
  getEventListBounds(experience, getDisplayTimezone(experience));

const clampAnchor = (
  anchor: DateTime,
  { start, end }: { start: DateTime; end: DateTime }
): DateTime => (anchor < start ? start : anchor > end ? end : anchor);

export const getDayRangeForAnchor = (
  anchor: DateTime,
  experience?: PageExperience
): DateTimeRange => {
  if (!experience) {
    const day = anchor.startOf('day');
    return { startDate: day, endDate: day.endOf('day') };
  }
  const inDisplayZone = anchor.setZone(getDisplayTimezone(experience), {
    keepLocalTime: true,
  });
  const day = clampAnchor(inDisplayZone, getDayRangeBounds(experience)).startOf(
    'day'
  );
  return { startDate: day, endDate: day.endOf('day') };
};

export const getDefaultDayRange = (experience: PageExperience): DateTimeRange =>
  getDayRangeForAnchor(
    DateTime.local({ zone: getDisplayTimezone(experience) }),
    experience
  );
